import { render, staticRenderFns } from "./labor.vue?vue&type=template&id=fb5f71c8&scoped=true&"
import script from "./labor.vue?vue&type=script&lang=ts&"
export * from "./labor.vue?vue&type=script&lang=ts&"
import style0 from "./labor.vue?vue&type=style&index=0&id=fb5f71c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5f71c8",
  null
  
)

export default component.exports